import { render, staticRenderFns } from "./CapabilitiesRenderer.vue?vue&type=template&id=216755a5&scoped=true&"
import script from "./CapabilitiesRenderer.vue?vue&type=script&lang=ts&"
export * from "./CapabilitiesRenderer.vue?vue&type=script&lang=ts&"
import style0 from "./CapabilitiesRenderer.vue?vue&type=style&index=0&id=216755a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216755a5",
  null
  
)

export default component.exports